import { useSnackbar } from "notistack";

function useNotify() {
  const { enqueueSnackbar } = useSnackbar();

  const success = (message) => {
    enqueueSnackbar(message, { variant: "success" });
  }
  const error = (message) => {
    enqueueSnackbar(message, { variant: "error" });
  }
  return {
    success,
    error,
  }
}

export default useNotify;
